import { Locale } from '@enmon/commons';
import { csCZ } from './locales/cs_CZ';
import { enUS } from './locales/en_US';
import { skSK } from './locales/sk_SK';
import { plPL } from './locales/pl_Pl';

/*
 *
 * LanguageProvider constants
 *
 */

export const ANTD_LOCALE_MAP = {
  [Locale.SK]: skSK,
  [Locale.CS]: csCZ,
  [Locale.EN]: enUS,
  [Locale.PL]: plPL,
} as const;

export const MAP_LOCALE_TO_DATE_FORMATS: Record<Locale, string[]> = {
  [Locale.CS]: ['D.M.YYYY', 'DD.MM.YYYY'],
  [Locale.SK]: ['D.M.YYYY', 'DD.MM.YYYY'],
  [Locale.PL]: ['D.M.YYYY', 'DD.MM.YYYY'],
  [Locale.EN]: ['M/D/YYYY', 'MM/DD/YYYY'],
};
